import React from 'react';
// @ts-ignore
import logoWhite from '../assets/images/ospitek_logo_with_tagline_white.svg';
// @ts-ignore
import logoDark from '../assets/images/ospitek_logo_with_tagline_blue.svg';
import { makeStyles, useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    // maxWidth: '100%',
  },
});

const Logo = ({ type, width, height }: { type?: 'light' | 'dark'; width?: number; height?: number }) => {
  const classes = useStyles();
  const theme = useTheme();
  const defaultType = theme.palette.type === 'light' ? logoDark : logoWhite;
  let logo: string | undefined;

  switch (type) {
    case 'light':
      logo = logoDark;
      break;
    case 'dark':
      logo = logoWhite;
      break;
    default:
      logo = defaultType;
  }

  return <img src={logo} alt="logo" className={classes.root} width={width || 180} height={height || 65} />;
};

export default Logo;
